module.exports = "<div class=\"<%= container %>\">\r\n    <div ng-click=\"$ctrl.setRoadMap()\"\r\n         class=\"<%= mapStyle %> <%= active %>\">\r\n        {{ 'fnol.pa.components.map-type-control.Map' | translate }}\r\n    </div>\r\n    <div ng-click=\"$ctrl.setSatelliteMap()\"\r\n         class=\"<%= mapStyle %>\">\r\n        {{ 'fnol.pa.components.map-type-control.Satellite' | translate }}\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/fnol/pa/components/MapTypeControl/MapTypeControl.html
// module id = 653
// module chunks = 0